/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalVodAlertNotification } from '../models/InternalVodAlertNotification';
import type { InternalVodStatusUpdate } from '../models/InternalVodStatusUpdate';
import type { session_id } from '../models/session_id';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InternalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Update VOD statuses from a cluster
     * Accepts VOD status updates pushed by a cluster remote service.
     * @returns any Status update accepted.
     * @throws ApiError
     */
    public internalVodControllerPostStatusUpdate({
        formData,
    }: {
        formData: InternalVodStatusUpdate,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/vod/status-update',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * Notify directors about a VOD alert
     * Accepts VOD alert notifications from a cluster and notifies the related contract directors.
     * @returns any Alert notification accepted.
     * @throws ApiError
     */
    public internalVodControllerPostNotifyAlert({
        requestBody,
    }: {
        requestBody: InternalVodAlertNotification,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/vod/notify-alert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
                404: `VOD not found.`,
                500: `Internal error.`,
            },
        });
    }
    /**
     * Notify that a Session reader is gone
     * Sent by a cluster when a destination stream of a Session is lost or expires: the matching consumer ends.
     * @returns any Notification accepted.
     * @throws ApiError
     */
    public internalSessionsControllerPostDestinationGone({
        requestBody,
    }: {
        requestBody: {
            session_id: session_id;
            /**
             * Public port of the destination media processor
             */
            port: number;
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/sessions/destination-gone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Notify that a Session is finished
     * Sent by a cluster when a Session stops: the Session and its remaining consumers end.
     * @returns any Notification accepted.
     * @throws ApiError
     */
    public internalSessionsControllerPostFinished({
        requestBody,
    }: {
        requestBody: {
            session_id: session_id;
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/sessions/finished',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Wrong syntax.`,
                401: `Unauthorized.`,
            },
        });
    }
}
